import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["identityEnvironment", "application", "continueUrl", "logOutContinueUrl", "isLoggedOut", "disableSwitchAccountLink"];
import React from 'react';
import AccountMenu from '@atlassian/account-menu';
import { useAccountLinks } from '../../hooks';
export var Account = function Account(_ref) {
  var identityEnvironment = _ref.identityEnvironment,
    application = _ref.application,
    continueUrl = _ref.continueUrl,
    logOutContinueUrl = _ref.logOutContinueUrl,
    isLoggedOut = _ref.isLoggedOut,
    disableSwitchAccountLink = _ref.disableSwitchAccountLink,
    props = _objectWithoutProperties(_ref, _excluded);
  var links = useAccountLinks({
    email: props.email,
    identityEnvironment: identityEnvironment,
    application: application,
    continueUrl: continueUrl,
    logOutContinueUrl: logOutContinueUrl,
    isLoggedOut: isLoggedOut,
    disableSwitchAccountLink: disableSwitchAccountLink
  });
  return /*#__PURE__*/React.createElement(AccountMenu, _extends({}, props, links));
};